export default "__VITE_ASSET__DyQ$5I61__"